import {call, put, takeLatest, fork, all, delay} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import * as CategoryAction from '../actions/supplierCategoryAction';
import * as CategoryService from './../services/supplierCategoryService';
import { parseListRequestParamsCameo } from '../utils/commonUtils';
import { PATHS, SAGA_DELAY_TIMEOUT } from '../constants/Define';
import history from './../helpers/history';

function* getListSupplierCategoryAll() {
    yield takeLatest(Types.SUPPLIER_CATEGORY_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(CategoryService.getSupplierCategoryAll, params);
        yield put(CategoryAction.setSupplierCategoryListAll(result));
    }, errorHandleSupplierCategory(Types.SUPPLIER_CATEGORY_FAIL)))
}

function* getListSupplierCategory() {
    yield takeLatest(Types.SUPPLIER_CATEGORY_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(CategoryService.getSupplierCategories, params);
        yield put(CategoryAction.setSupplierCategoryList(result));
    }, errorHandleSupplierCategory(Types.SUPPLIER_CATEGORY_FAIL)))
}

function* createSupplierCategoryDetail() {
    yield takeLatest(Types.SUPPLIER_CATEGORY_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(CategoryService.createSupplierCategory, action.category);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.supplierCategory.title')} "${action.category.name}"` });
        yield put({ type: Types.SUPPLIER_CATEGORY_CREATE_SUCCESS });
        history.push(PATHS.SUPPLIER_CATEGORY.LIST.path);
        history.go();
    }, errorHandleSupplierCategory(Types.SUPPLIER_CATEGORY_FAIL)))
}

function* getSupplierCategoryDetail() {
    yield takeLatest(Types.SUPPLIER_CATEGORY_GET_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CategoryService.getSupplierCategoryDetail, action.id);
        yield put(CategoryAction.setSupplierCategoryDetail(result));
    }, errorHandleSupplierCategory(Types.SUPPLIER_CATEGORY_FAIL)))
}

function* updateSupplierCategoryDetail() {
    yield takeLatest(Types.SUPPLIER_CATEGORY_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(CategoryService.updateSupplierCategory, action.category);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.supplierCategory.title')} "${action.category.name}"` })
        // yield put(RateCodeAction.setRateCodeDetail(action.rateCode));
        history.push(PATHS.SUPPLIER_CATEGORY.LIST.path);
        history.go();
    }, errorHandleSupplierCategory(Types.SUPPLIER_CATEGORY_FAIL)))
}

function* deleteSupplierCategory() {
    yield takeLatest(Types.SUPPLIER_CATEGORY_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(CategoryService.deleteSupplierCategory, action.category.id);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}`, description: `${i18n.t('item.supplierCategory.title')} "${action.category.name}"` });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put(CategoryAction.getSupplierCategoryList(action.refreshParams || {}));
    }, errorHandleSupplierCategory(Types.SUPPLIER_CATEGORY_FAIL)))
}

function errorHandleSupplierCategory(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'supplierCategory');
}


export function* supplierCategorySaga() {
    yield all([
        fork(getListSupplierCategoryAll),
        fork(getListSupplierCategory),
        fork(createSupplierCategoryDetail),
        fork(getSupplierCategoryDetail),
        fork(updateSupplierCategoryDetail),
        fork(deleteSupplierCategory)
    ])
}
